import { TeamsTab } from '../../admin/components/TeamsTab'

export function PlatformTeamsPage(): JSX.Element {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Teams</h1>
        <p className="mt-1 text-sm text-gray-500">View and manage teams across all properties</p>
      </div>
      <TeamsTab />
    </div>
  )
}
